import { render, staticRenderFns } from "./Datapolicy.vue?vue&type=template&id=46740216&"
import script from "./Datapolicy.vue?vue&type=script&lang=js&"
export * from "./Datapolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports